import React, { useState, useEffect } from 'react';
import {useDispatch, useSelector} from "react-redux";

import PSLoading from "../../components/PSLoading";
import PSDynamicBasicTable from '../../components/PSDynamicBasicTable';
import ContactService from "../../shared/services/ContactService";
import { ContactModel } from "../../shared/model/ContactModel";

import { HEADER_CONTACTS } from '../../../scripts/Constants';

import './index.scss';


export default function ContactPage() {

  const [listContact, setListContact] = useState([]);
  const [loading, setLoading] = useState(true);
  const user = useSelector((state) => state.user);
  // const { idOrg } = user;

  const loadContact = async () => {
    try{
      const response  = await ContactService.responseGetContact();
      const contacts = response.data.map((data) => new ContactModel(data));
      const contactsAvailable = contacts.filter(c => c.idOrganization == user.idOrg);
    
      setListContact([...contactsAvailable]);
    }catch (error){
      console.log("errr",error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(()=>{
    loadContact();
  },[]);

  return(
    <div>
      {
        loading ?
				<div className="d-flex-center">
					<PSLoading color="red"/>
				</div>:
				<div> 
					<h2>Contactos</h2>
          <p>En esta sección encontrara un listado de solicitudes de contactos a su negocio</p>
					<hr />
					<PSDynamicBasicTable headers={HEADER_CONTACTS} items={listContact} ></PSDynamicBasicTable>
				</div>
      }
    </div>
  )
}